import Vue from "vue";
import messagingService from "../api/messagingService";
import { unescape } from "html-escaper";
import * as DOMPurify from "dompurify";

Vue.prototype.$notification = messagingService;
Vue.prototype.$unescapeHtml = (text) => {
  return unescapeExtraChar(unescape(text));
};

Vue.prototype.$sanitizeHtml = (text) => {
  return sanitizeHtml(text);
};

function unescapeExtraChar(s) {
  if (isEmpty(s)) return s;

  return s.replace(/&#x27;/g, "'");
}

function isEmpty(value) {
  return (
    value == null || (typeof value === "string" && value.trim().length === 0)
  );
}

function sanitizeHtml(str) {
  return DOMPurify.sanitize(str);
}
